import { Component, OnInit, ViewChild, ElementRef, Input, EventEmitter, Output, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FontService } from 'src/app/model/api-services/font.service';
import { FontDriver, FontDef, FontRef, FontStyle } from 'src/app/types/sl-fonts';

@Component({
	selector: 'app-font-selector',
	templateUrl: './font-selector.component.html',
	styleUrls: ['./font-selector.component.scss'],
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class FontSelectorComponent implements OnInit {


	@Input() fontName = '';

	@Input()
	set font(fontId) {
		this.targetFont = fontId;
	}
	get font(): string {
		return this.targetFont;
	}
	@Output() fontChange = new EventEmitter<string>();


	private targetFont = '';
	public driverReady = false;

	public driver: FontDriver;
	public selectedFont: FontRef;
	public selectedStyle: FontStyle;
	public fonts: Array<FontRef> = [];
	public styles: Array<FontStyle> = [];
	public stylesReady = false;
	public styleName = '';
	public isItalic = false;

	public useItalic = false;

	@ViewChild('family_sel', { static: true }) familySel: ElementRef;
	@ViewChild('style_sel', { static: true }) styleSel: ElementRef;
	@ViewChild('italic_cb', { static: true }) italicCB: ElementRef;

	constructor(private fontService: FontService,private changes:ChangeDetectorRef) { }

	get value(): string {
		if (!!this.selectedStyle) {
			if (this.italicCB.nativeElement.checked === true) {
				return this.selectedStyle.value_i;
			}
			return this.selectedStyle.value;
		}
		return '';
	}

	set value(fontString: string) {		
		if (fontString === 'Vera') { return; }
		const fname: string = fontString;
		let useItalic = false;

		const matches: Array<any> = fname.match(/[ABCDEFGHIJKLMNOPQRSTUVWXYZ_][abcdefghijklmnopqrstuvwxyz]+/g);
		if (matches.slice(-1).pop() === 'Italic') {
			matches.pop();
			useItalic = true;
		}
		
		for (const fontRef of this.driver.fonts) {
			for (const style of fontRef.font.styles) {
				const fontName = (useItalic) ? style.value_i : style.value;
				if (fontName === fontString) {
					this.selectedFont = fontRef;
					this.selectedStyle = style;
					this.isItalic = useItalic;
					this.fontName = fontRef.name;
					this.styleName = style.name;
					this.useItalic = style.italic;

				}
			}
		}
	}

	ngOnInit() {
		this.Setup();
	}
	Setup() {
		this.driverReady = false;
		this.fontService.ListFonts().then((driver: FontDriver) => {
			this.driver = driver;
			this.fonts = this.driver.fonts;
			this.fontName = '';
			for (const fontRef of this.fonts) {
				for (const style of fontRef.font.styles) {
					let useItalic = false;
					if (this.font.toLowerCase().substr(-6) === 'italic') {
						useItalic = true;
					}
					if (this.font === (useItalic ? style.value_i : style.value)) {
						this.fontName = fontRef.name;
						this.selectedFont = fontRef;
						this.styles = this.selectedFont.font.styles;
						this.selectedStyle = style;
						this.styleName = style.name;
						this.isItalic = style.italic;
						this.useItalic = useItalic;
						this.stylesReady = true;
						this.driverReady = true;
						this.changes.detectChanges();
						return;
					}
				}

			}
			this.driverReady = true;
			this.selectedStyle = undefined;
			this.isItalic = false;
			this.changes.detectChanges();
		});
	}
	FamilySelected(event) {
		this.stylesReady = false;
		for (const font of this.driver.fonts) {
			if (font.name === event.target.value) {
				this.selectedFont = font;
			}
		}
		this.styleName = '';
		this.selectedStyle = undefined;
		this.isItalic = false;
		this.styles = this.selectedFont.font.styles;
		this.stylesReady = true;
		this.changes.detectChanges();

	}
	FamilyPopulated() {
		this.FamilySelected({ target: { value: this.driver.fonts[0].name } });
		this.changes.detectChanges();
	}
	StyleSelected(event) {
		this.selectedStyle = undefined;
		this.isItalic = false;
		for (const style of this.styles) {
			if (style.name === this.styleName) {
				this.isItalic = style.italic;
				this.selectedStyle = style;
				this.UpdateFontName(style.value);
				return;
			}
		}
		this.changes.detectChanges();

	}
	ItalicChanged(event) {
		const style = this.selectedStyle;
		this.UpdateFontName(this.isItalic ? style.value_i : style.value);
		this.changes.detectChanges();
	}
	UpdateFontName(name: string) {
		this.targetFont = name;
		this.fontChange.emit(this.targetFont);
		this.changes.detectChanges();
	}
}
